import { render, staticRenderFns } from "./ViewHolder.vue?vue&type=template&id=54116cb6&scoped=true"
import script from "./ViewHolder.vue?vue&type=script&lang=ts"
export * from "./ViewHolder.vue?vue&type=script&lang=ts"
import style0 from "./ViewHolder.vue?vue&type=style&index=0&id=54116cb6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54116cb6",
  null
  
)

export default component.exports